import { AddTodo } from 'almanac-ui/icons/16'
import { Todo } from 'api/clients/TodoClient'
import { CreateTodoPrompt } from 'common/Prose/Prompts/CreateTodoPrompt/CreateTodoPrompt'
import { createTodoMark, createTodoUuidOnNode } from 'common/Prose/Prompts/CreateTodoPrompt/createTodoSubmit'
import { schema } from 'prose-core'
import { StrongNodeType } from 'prose-core'
import { NodeSelection } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'
import React from 'react'
import { QueryClient } from 'react-query'
import { DocStore } from 'stores/DocStore'
import { ProseDropdownPrompt } from '../ProseDropdownPrompt/ProseDropdownPrompt'

type TodoInlineFormatButtonProps = {
  view: EditorView
  queryClient: QueryClient
  docStore: DocStore | null
  hide: boolean
  nodePos?: number
  onOpenChange?: (open: boolean) => void
  overrideSelectionRange?: { from: number; to: number }
}

export const NODES_WITH_TASKUUIDS = [schema.nodes.card, schema.nodes.mermaid_embed]

export const TodoInlineFormatButton: React.FC<React.PropsWithChildren<TodoInlineFormatButtonProps>> = (props) => {
  const {
    view,
    queryClient,
    docStore,
    hide,
    nodePos,
    onOpenChange,
    overrideSelectionRange,
  } = props
  if (!docStore || hide) return null

  const onCreateCallback = (close: () => void, todo: Todo) => {
    if (
      nodePos !== undefined &&
      view.state.selection instanceof NodeSelection &&
      NODES_WITH_TASKUUIDS.includes(view.state.selection.node.type as StrongNodeType<any, any>)
    ) {
      createTodoUuidOnNode(view, nodePos, close)(todo)
    } else {
      createTodoMark(view, close, overrideSelectionRange)(todo)
    }
  }

  return (
    <ProseDropdownPrompt
      view={view}
      anchorChildren={<AddTodo />}
      label="Create task"
      onOpenChange={onOpenChange}
      dropdownComponent={(close) => {
        const handleClose = () => {
          close()
          view.focus()
        }

        return (
          <CreateTodoPrompt
            onCreate={(todo) => onCreateCallback(handleClose, todo)}
            onCancel={handleClose}
            view={view}
            queryClient={queryClient}
            docStore={docStore}
          />
        )
      }}
    />
  )
}
